export const HeroRarity = {
  Common: 0,
  Rare: 1,
  Epic: 2,
  Legendary: 3,
} as const;

export const HeroRarityRu: Record<number, string> = {
  0: "Common",
  1: "Rare",
  2: "Epic",
  3: "Legendary",
};

// Rarity color uses dual-tone (light/dark theme) so the badge stays
// readable on both: solid 600-shade on light background, lighter 300-shade
// on dark Telegram theme via the `data-theme="dark"` selector.
export const HeroRarityColor: Record<number, string> = {
  0: "text-tg-hint",
  1: "text-blue-600 dark:text-blue-300",
  2: "text-purple-600 dark:text-purple-300",
  3: "text-yellow-600 dark:text-yellow-300",
};

// Passive buff a hero contributes to the whole army (or to a specific class
// of units). Server pre-formats `summary` in Russian so the UI doesn't need
// to know the translation table for StatKind/UnitClass.
export interface HeroPassive {
  stat: string;                     // "Attack" | "Defense" | "Hp"
  appliesToClass: string | null;    // null = all classes
  percentBonus: number;
  summary: string;                  // e.g. "+20% Атака всем" — ready to render
}

// Active skill that fires every CooldownRounds-th battle round.
export interface HeroSkill {
  id: string;
  name: string;
  description: string;
  cooldownRounds: number;
  kind: string;                     // "AoE-урон" | "Лечение" | "Бафф"
  appliesToClass: string | null;
  magnitude: number;
  durationRounds: number;
}

export interface HeroEntry {
  id: string;
  name: string;
  level: number;
  stars: number;
  rarity: number;
  owned: boolean;
  // New (after Crystal-of-Heroes rework 2026-05-22):
  // recruitment costs N named shards of THIS hero (collected via crystal
  // roulette or by converting universal shards of the same rarity).
  recruitShardCost: number;
  currentHeroShards: number;
  requiresHeroHall: number;
  currentHeroHall: number;
  currentCastleLevel: number;
  currentHeroXp: number;
  canLevelUp: boolean;
  levelUpXpCost: number;
  nextLevel: number | null;
  maxLevel: number;
  canStarUp: boolean;
  starUpShardsCost: number;   // star-up also in named shards now
  nextStar: number | null;
  maxStars: number;
  // Ability summary surfaced 2026-05-22 so the player can see what a hero
  // actually does before picking them for an army.
  passives?: HeroPassive[];
  skills?: HeroSkill[];
}

export const HeroCrystalTier = {
  Dim: 1,
  Shining: 2,
  Ancient: 3,
} as const;

export const HeroCrystalTierName: Record<number, string> = {
  1: "Тусклый",
  2: "Сияющий",
  3: "Древний",
};
